<template>
  <div>
    <el-card class="">
      <div slot="header" class=" flex justify-between">
        <div>{{ $t('housekeepingFeeType.queryCondition') }}</div>
        <div class="ibox-tools" style=""></div>
      </div>
      <div class="">
        <el-form :inline="true" :model="housekeepingFeeTypeInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="housekeepingFeeTypeInfo.conditions.typeName"
                :placeholder="$t('housekeepingFeeType.typeNamePlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="housekeepingFeeTypeInfo.conditions.isShow"
                :placeholder="$t('housekeepingFeeType.isShowPlaceholder')" style="width:100%" clearable>
                <el-option v-for="item in housekeepingFeeTypeInfo.isShows" :key="item.statusCd" :label="item.name"
                  :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryHousekeepingFeeTypeMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetHousekeepingFeeTypeMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('housekeepingFeeType.feeType') }}</div>
        <div class="ibox-tools" style="top:10px;">
          <el-button type="primary" size="small" @click="_openAddHousekeepingFeeTypeModal">
            <i class="el-icon-plus"></i> {{ $t('common.add') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="housekeepingFeeTypeInfo.types" border style="width: 100%">
          <el-table-column prop="typeName" :label="$t('housekeepingFeeType.typeName')" align="center" />
          <el-table-column prop="isShow" :label="$t('housekeepingFeeType.isShow')" align="center">
            <template slot-scope="scope">
              {{ scope.row.isShow == 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('housekeepingFeeType.createTime')" align="center" />
          <el-table-column prop="remark" :label="$t('housekeepingFeeType.remark')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_openEditHousekeepingFeeTypeModel(scope.row)">
                {{ $t('common.edit') }}
              </el-button>
              <el-button type="text" size="small" @click="_openDeleteHousekeepingFeeTypeModel(scope.row)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="housekeepingFeeTypeInfo.conditions.page"
          :page-size="housekeepingFeeTypeInfo.conditions.row" layout="total, prev, pager, next"
          :total="housekeepingFeeTypeInfo.total" />
      </div>
    </el-card>

    <add-housekeeping-fee-type ref="addHousekeepingFeeType" @refresh="_queryHousekeepingFeeTypeMethod" />
    <edit-housekeeping-fee-type ref="editHousekeepingFeeType" @refresh="_queryHousekeepingFeeTypeMethod" />
    <delete-housekeeping-fee-type ref="deleteHousekeepingFeeType" @refresh="_queryHousekeepingFeeTypeMethod" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryHousekeepingFeeType } from '@/api/housekeeping/housekeepingFeeTypeApi'

export default {
  name: 'HousekeepingFeeType',
  components: {
    'add-housekeeping-fee-type': () => import('@/components/housekeeping/addHousekeepingFeeType'),
    'edit-housekeeping-fee-type': () => import('@/components/housekeeping/editHousekeepingFeeType'),
    'delete-housekeeping-fee-type': () => import('@/components/housekeeping/deleteHousekeepingFeeType')
  },
  data() {
    return {
      housekeepingFeeTypeInfo: {
        types: [],
        total: 0,
        records: 1,
        moreCondition: false,
        feeTypeCd: '',
        isShows: [],
        conditions: {
          typeName: '',
          isShow: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      this.housekeepingFeeTypeInfo.conditions.shopId = getShopId()
      await this._listHousekeepingFeeTypes(1, 10)
      this._getDictData()
    },
    async _getDictData() {
      try {
        const { data } = await getDict('housekeeping_type', 'is_show')
        this.housekeepingFeeTypeInfo.isShows = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listHousekeepingFeeTypes(page, rows) {
      this.housekeepingFeeTypeInfo.conditions.page = page
      this.housekeepingFeeTypeInfo.conditions.row = rows
      try {
        const res = await queryHousekeepingFeeType(this.housekeepingFeeTypeInfo.conditions)
        this.housekeepingFeeTypeInfo.total = res.total
        this.housekeepingFeeTypeInfo.records = res.records
        this.housekeepingFeeTypeInfo.types = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listHousekeepingFeeTypes(val, this.housekeepingFeeTypeInfo.conditions.row)
    },
    _openAddHousekeepingFeeTypeModal() {
      this.$refs.addHousekeepingFeeType.open()
    },
    _openEditHousekeepingFeeTypeModel(row) {
      this.$refs.editHousekeepingFeeType.open(row)
    },
    _openDeleteHousekeepingFeeTypeModel(row) {
      this.$refs.deleteHousekeepingFeeType.open(row)
    },
    _queryHousekeepingFeeTypeMethod() {
      this._listHousekeepingFeeTypes(1, this.housekeepingFeeTypeInfo.conditions.row)
    },
    _resetHousekeepingFeeTypeMethod() {
      this.housekeepingFeeTypeInfo.conditions.typeName = ''
      this.housekeepingFeeTypeInfo.conditions.isShow = ''
      this._listHousekeepingFeeTypes(1, this.housekeepingFeeTypeInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>